import * as React from "react";
import { Button } from "react-ui";

interface Props {
    children?: JSX.Element | string;
    onClick: () => void;
}

export function ReplaceButton(props: Props): JSX.Element {
    return (
        <Button use="link" onClick={props.onClick}>
            {props.children}
        </Button>
    );
}
